// extracted by mini-css-extract-plugin
export default {"transferFrom":"TransferFrom_transferFrom__2kCdj","container":"TransferFrom_container__2H8bN","title":"TransferFrom_title__2loNs"};